/**
 * Location slice Tracks current window.location in Redux store
 */
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	pathname: typeof window !== 'undefined' ? window.location.pathname : '/',
	search: typeof window !== 'undefined' ? window.location.search : '',
	hash: typeof window !== 'undefined' ? window.location.hash : '',
	href: typeof window !== 'undefined' ? window.location.href : '',
}

export const locationSlice = createSlice({
	name: 'location',
	initialState,
	reducers: {
		setLocation: (state, action) => {
			const { pathname, search, hash, href } = action.payload
			state.pathname = pathname
			state.search = search
			state.hash = hash
			state.href = href
		},
		updatePathname: (state, action) => {
			state.pathname = action.payload
			state.href = window.location.origin + action.payload + state.search + state.hash
		},
		updateSearch: (state, action) => {
			state.search = action.payload
			state.href = window.location.origin + state.pathname + action.payload + state.hash
		},
		updateHash: (state, action) => {
			state.hash = action.payload
			state.href = window.location.origin + state.pathname + state.search + action.payload
		},
	},
})

export const { setLocation, updatePathname, updateSearch, updateHash } = locationSlice.actions

export default locationSlice.reducer
